<template>
    <el-dialog @close='closeDialog' title="导入商品素材" :visible.sync="dialogVisible">
        <div class="goods_material_box">
            <div class="left_box">
                <p @click="goodsClassClick(-1)" :class="classMenu === -1 ? 'isactive' : 'noactive'">全部分类</p>
                <p @click="goodsClassClick(index, item.innerid)" :class="classMenu === index ? 'isactive' : 'noactive'" v-for="(item, index) in goodsClassData" :key="index">{{item.name}}</p>
            </div>
            <div class="right_box">
                <div class="search_box">
                    <div style="width: 502px; margin-right: 20px;">
                        <el-input v-model="goodsName" placeholder="输入商品名称" class="input item"></el-input>
                    </div>
                    <el-button type="primary" @click="searchBtn" plain>搜索</el-button>
                </div>
                <div class="goods_class_list_box">
                    <el-table :show-header="false" :data="goodsData" style="width: 100%" @select="selected" ref="multipleTable">
                        <el-table-column type="selection" width="30"></el-table-column>
                        <el-table-column label="商品名称" prop="name">
                            <template slot-scope="scope">
                                <div class="goods_info_box">
                                    <img :src="scope.row.logoatturlid" alt="">
                                    <div>
                                        <p>{{scope.row.name}}</p>
                                        <p>{{scope.row.saleprice}}</p>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page_box">
                    <el-pagination
                        background
                        @current-change="handleSizeChange"
                        :current-page.sync="pageParams.page"
                        :page-size="pageParams.pageSize"
                        :pager-count="11"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sureClick()">确 定</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Page from 'base/page/page'
import {getMaterialsList, searchMaterialList} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'AddGoodsPop',
    props: ['goodsClassData'],
    data() {
        return {
            goodsClassId: '',
            classMenu: -1,
            dialogVisible: false,
            goodsName:　'',
            pageParams: {
                page: 1,
                pageSize: 5
            },
            goodsData: [],
            total: 0,
            selectedResult: ''
        }
    },
    mounted() {},
    methods: {
        // 商品分类搜索
        goodsClassClick(val, classId) {
            this.classMenu = val
            this.goodsName = ''
            this.page.page = 1
            if (val === -1) {
                this.goodsClassId = ''
                this.findGoodsList()
            } else {
                this.goodsClassId = classId
                this.findGoodsClassList(classId)
            }
        },
        // 打开弹窗
        openDialog() {
            this.dialogVisible = true
            this.goodsClassId = ''
            this.classMenu = -1
            this.findGoodsList()
            // if (this.goodsData.length === 0) {
            //     this.findGoodsList()
            // }
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
            // this.classMenu = -1
        },
        // 获取商品素材
        findGoodsList() {
            this.setLoading(true)
            var params = {
                page: this.page.page,
                pageSize: 5
            }
            searchMaterialList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取商品分类列表下素材
        findGoodsClassList(value) {
            this.setLoading(true)
            var params = {
                page: this.page.page,
                pageSize: 5,
                catecode: value
            }
            searchMaterialList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 商品列表分页及搜索
        handleSizeChange(val) {
            this.setLoading(true)
            var params = {
                catecode: this.goodsClassId
            }
            searchMaterialList({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        searchBtn() {
            this.setLoading(true)
            var params = {
                productname: this.goodsName,
                catecode: this.goodsClassId,
                page: this.page.page,
                pageSize: 5
            }
            searchMaterialList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },

        selected(selection, row) {
            this.$refs.multipleTable.clearSelection()
            this.$refs.multipleTable.toggleRowSelection(row)
            this.selectedResult = row
        },

        // 确定添加商品
        sureClick() {
            // console.log(this.selectedResult === '')
            if (this.selectedResult === '') {
                this.$message.error('请选择商品！')
            } else {
                this.dialogVisible = false
                this.$emit('sureAddGoods', this.selectedResult)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        goodsClassData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log(this.goodsClassData)
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .goods_material_box{
        background-color: rgb(255, 255, 255);
        height: 592px;
        display: flex;
        justify-content: space-between;
        .left_box{
            overflow-y: scroll;
            overflow-x: hidden;
            // overflow-y: auto;
            // border-right: 1px solid #DCDFE6;
            p{
                width: 150px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fff;
                color: #36383A;
                cursor: pointer;
            }
            p:hover{
                background-color: #E6F1FC;
                color: #409EFF;
            }
            .isactive{
                background-color: #E6F1FC;
                color: #409EFF;
            }
        }
        .right_box{
            flex: 1;
            padding: 10px;
            .search_box{
                display: flex;
                margin-bottom: 10px;
                .el-input__inner {
                    height: 36px;
                }
                .el-button {
                    margin-bottom: 0px;
                    height: 36px;
                }
            }
            .goods_class_list_box{
                // .el-table__empty-block {
                //     min-height: 300px;
                // }
                .el-table__body-wrapper {
                    min-height: 368px;
                }
                .el-table__empty-block {
                    box-sizing: border-box;
                    padding-top: 140px;
                    min-height: 368px;
                    // background-size: 300px 230px !important;
                }
                .goods_info_box{
                    padding: 0;
                    display: flex;
                    &>img{
                        width: 50px;
                        height: 50px;
                        margin-right: 18px;
                    }
                    &>div{
                        // background-color: #fff;
                        // padding: 5px 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        p:nth-of-type(1){
                            color: #303133;
                        }
                        p:nth-of-type(2){
                            color: #F56C6C;
                        }
                    }
                }
            }
            .page_box{
                margin: 30px 0;
                @include flexBox(center)
            }
        }
    }
</style>